import Icon from '@/components/ui/AppIcon';

interface ServiceCategoryCardProps {
  icon: 'BriefcaseIcon' | 'GlobeAltIcon' | 'UserGroupIcon' | 'AcademicCapIcon';
  title: string;
  description: string;
  features: string[];
  isExpanded: boolean;
  onToggle: () => void;
}

export default function ServiceCategoryCard({
  icon,
  title,
  description,
  features,
  isExpanded,
  onToggle,
}: ServiceCategoryCardProps) {
  return (
    <div className="card-base card-hover overflow-hidden">
      {/* Card Header */}
      <button
        onClick={onToggle}
        className="w-full p-8 text-left flex items-start gap-6 hover:bg-muted/50 transition-colors"
      >
        <div className="w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg">
          <Icon name={icon} size={32} className="text-white" />
        </div>

        <div className="flex-grow">
          <h3 className="text-2xl font-heading font-bold text-foreground mb-2 uppercase tracking-wide">
            {title}
          </h3>
          <p className="text-muted-foreground leading-relaxed">
            {description}
          </p>
        </div>

        <Icon
          name={isExpanded ? 'ChevronUpIcon' : 'ChevronDownIcon'}
          size={24}
          className="text-primary flex-shrink-0 transition-transform"
        />
      </button>

      {/* Expandable Content */}
      {isExpanded && (
        <div className="px-8 pb-8 animate-fadeIn">
          <div className="pl-22 space-y-3 border-l-4 border-accent ml-8">
            <h4 className="text-lg font-bold text-foreground uppercase tracking-wider mb-4 pl-6">
              Key Deliverables:
            </h4>
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex items-start gap-4 pl-6 animate-fadeIn"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                <div className="mt-1 w-6 h-6 bg-success/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="CheckIcon" size={16} className="text-success" />
                </div>
                <span className="text-foreground font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}